'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_core_Signal$() {
  this.lu = 0;
  this.lu = 0;
}
export { $c_Lcom_raquo_airstream_core_Signal$ as $c_Lcom_raquo_airstream_core_Signal$ };
$p = $c_Lcom_raquo_airstream_core_Signal$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_Signal$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_Signal$() {
}
export { $h_Lcom_raquo_airstream_core_Signal$ as $h_Lcom_raquo_airstream_core_Signal$ };
$h_Lcom_raquo_airstream_core_Signal$.prototype = $p;
$p.PJ = (function() {
  if ((this.lu === 2147483647)) {
    this.lu = 1;
  } else {
    this.lu = ((1 + this.lu) | 0);
  }
  return this.lu;
});
var $d_Lcom_raquo_airstream_core_Signal$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_core_Signal$, "com.raquo.airstream.core.Signal$", ({
  gO: 1
}));
export { $d_Lcom_raquo_airstream_core_Signal$ as $d_Lcom_raquo_airstream_core_Signal$ };
var $n_Lcom_raquo_airstream_core_Signal$;
function $m_Lcom_raquo_airstream_core_Signal$() {
  if ((!$n_Lcom_raquo_airstream_core_Signal$)) {
    $n_Lcom_raquo_airstream_core_Signal$ = new $c_Lcom_raquo_airstream_core_Signal$();
  }
  return $n_Lcom_raquo_airstream_core_Signal$;
}
export { $m_Lcom_raquo_airstream_core_Signal$ as $m_Lcom_raquo_airstream_core_Signal$ };
